import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Reply.svg",
  "use": "Reply.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Reply.svg\"><path d=\"M52.3189,51.0208a1.6712,1.6712,0,0,1-1.6019-1.1647c-2.2527-7.303-8.4941-10.8323-18.6955-10.835v8.0111A2.0031,2.0031,0,0,1,28.7362,48.57L10.71,33.5574a2.0006,2.0006,0,0,1,0-3.0753L28.7362,15.47a2.0031,2.0031,0,0,1,3.2853,1.5377v8.0139c14.2738.7267,21.4648,9.365,21.9865,24.2249A1.7,1.7,0,0,1,52.3189,51.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol